import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FilterSituationFamilialeByNamePipe } from 'src/app/shared/pipes/filter-situationFamiliale-by-name/filter-situationFamiliale-by-name.pipe';
import { ParametrageModule } from '../parametrage/parametrage.module';
import { ListSituationFamilialeComponent } from './list-situationFamiliale/list-situationFamiliale.component';
import { SituationFamilialeModalAjoutComponent } from './modal/situationFamiliale-modal-ajout/situationFamiliale-modal-ajout.component';
import { SituationFamilialeModalDetailComponent } from './modal/situationFamiliale-modal-detail/situationFamiliale-modal-detail.component';

@NgModule({
	declarations: [
		ListSituationFamilialeComponent,
		SituationFamilialeModalDetailComponent,
		SituationFamilialeModalAjoutComponent
	],
	imports: [SharedModule, ParametrageModule],
	providers: [FilterSituationFamilialeByNamePipe]
})

export class SituationFamilialeModule {}
